import React, { FC } from 'react';

import { Filter, FilterProps, TextInput } from 'react-admin';

export const TaskFilter: FC<Omit<FilterProps, 'children'>> = props => (
  <Filter {...props}>
    <TextInput alwaysOn label="Search" resettable source="search" />
  </Filter>
);
